<template>
  <div>
    <div class="row">
      <div v-if="activeElement.hasImage" class="col-l-6 col-m-12 offset-bottom-2 pull-right text-right">
        <img :src="`delegates/barring/content/businesspartner/${activeElement.bpNumber}`" alt="" aria-hidden="true" class="logo offset-right-1" />
        <!-- #D338 -->
      </div>
      <div :class="activeElement.hasImage ? 'col-l-6 col-m-12 pull-left' : 'col-xl-12 col-l-12 col-m-12 col-s-12'">
        <VSection label="persistentconfirmations.customer_view_partner_information_headline">
          <VDescriptionList>
            <VEntry :data="partnerDetails" field="data.name" name="common.customer_view_partner_information_partner_name" />
            <VEntry :data="partnerDetails" field="data.website" name="common.customer_view_partner_information_website" />
            <VEntry :data="partnerDetails" field="data.phone" name="common.customer_view_partner_information_hotline" />
            <VEntry :data="partnerDetails" field="data.fax" name="common.customer_view_partner_information_fax" />
            <VEntry :data="partnerDetails" field="data.taxNumber" name="common.customer_view_partner_information_taxno" />
            <VEntry :data="partnerDetails" field="data.email" name="common.customer_view_partner_information_email" />
            <VEntry v-slot="{ value }" :data="partnerDetails" field="data" name="common.customer_view_partner_information_address">
              <VAddress :data="value" />
            </VEntry>
          </VDescriptionList>
        </VSection>
      </div>
    </div>

    <VSection label="persistentconfirmations.details_customer_view_headline">
      <VDescriptionList>
        <VEntry v-slot="{ value }" :data="activeElement" field="status" name="persistentconfirmations.details_status">
          {{ $tm('persistentconfirmations.status_', value) }}
        </VEntry>
        <VEntryDate :data="activeElement" field="nextIdealChargingDate" name="persistentconfirmations.details_nextidealchargingdate" />
        <VEntryDate :data="activeElement" field="finalExpiryDate" name="persistentconfirmations.details_finalexpirydate" />
        <VEntryDate :data="activeElement" field="deletionDate" name="persistentconfirmations.details_deletiondate" />
      </VDescriptionList>
    </VSection>

    <VSection label="persistentconfirmations.details_charging_info">
      <VDescriptionList>
        <VEntry :data="activeElement" field="serviceDescription" name="persistentconfirmations.details_service_description" />
        <VEntryNumber currency-field="currency" :divide="100" :data="activeElement" field="grossAmount" name="persistentconfirmations.details_service_price" />
        <VEntry v-slot="{ value }" name="persistentconfirmations.details_service_charging_cycle" :data="activeElement" field="chargingCycle">{{
          convertChargingCycle(value)
        }}</VEntry>
      </VDescriptionList>
    </VSection>

    <VSection label="persistentconfirmations.details_creation_info">
      <VDescriptionList>
        <VEntry
          v-if="
            hasRightPaymentTransactions && activeElement.creationDate && activeElement.xid && isWithinTimeFrame(activeElement.creationDate, maximumTimeFrame)
          "
          name="persistentconfirmations.details_creation_taid"
        >
          <VButton
            class="btn-default btn-small offset-bottom-1"
            :label="activeElement.xid"
            :title="$tt('persistentconfirmations.details_creation_taid')"
            :to="{
              name: PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
              params: {
                from: formatDateUrl(activeElement.creationDate),
                to: formatDateUrl(activeElement.creationDate),
                transactionId: activeElement.xid,
                tab: $route.params.tab,
              },
            }"
          />
        </VEntry>
        <VEntry v-else :data="activeElement" field="xid" name="persistentconfirmations.details_creation_taid" />
        <VEntryDate :data="activeElement" field="creationDate" name="persistentconfirmations.details_creation_date" />
      </VDescriptionList>
    </VSection>

    <VSection label="persistentconfirmations.details_reusage_info">
      <VDescriptionList>
        <VEntry
          v-if="
            hasRightPaymentTransactions &&
              activeElement.lastUsageDate &&
              activeElement.reusedByTaId &&
              isWithinTimeFrame(activeElement.lastUsageDate, maximumTimeFrame)
          "
          name="persistentconfirmations.details_creation_taid"
        >
          <VButton
            class="btn-default btn-small offset-bottom-1"
            :label="activeElement.reusedByTaId"
            :title="$tt('persistentconfirmations.details_reusage_taid')"
            :to="{
              name: PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
              params: {
                from: formatDateUrl(activeElement.lastUsageDate),
                to: formatDateUrl(activeElement.lastUsageDate),
                transactionId: activeElement.reusedByTaId,
                tab: $route.params.tab,
              },
            }"
          />
        </VEntry>
        <VEntry v-else :data="activeElement" field="reusedByTaId" name="persistentconfirmations.details_reusage_taid" />
        <VEntryDate :data="activeElement" field="lastUsageDate" name="persistentconfirmations.details_reusage_date" />
      </VDescriptionList>
    </VSection>
  </div>
</template>

<script>
import { convertChargingCycle } from '@/utils/price';
import VSection from '@/components/Section';
import VButton from '@/components/Button';
import { mapGetters } from 'vuex';
import { PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS } from '@route-types';
import { isWithinTimeFrame, formatDateUrl } from '@/utils/date';

export default {
  name: 'PersistentConfirmationsDetails',

  components: {
    VSection,
    VButton,
    VDescriptionList: () => import('@/components/DescriptionList'),
    VEntry: () => import('@/components/DescriptionList/Entry'),
    VEntryDate: () => import('@/components/DescriptionList/EntryDate'),
    VEntryNumber: () => import('@/components/DescriptionList/EntryNumber'),
    VAddress: () => import('@/components/Address'),
  },

  props: {
    partnerDetails: {
      type: Object,
      required: false,
      default: null,
    },
    activeElement: {
      type: Object,
      required: true,
    },
    maximumTimeFrame: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
    };
  },

  computed: {
    ...mapGetters('system', {
      hasRightPaymentTransactions: 'hasAccessPaymentTransactions',
    }),
  },

  methods: {
    convertChargingCycle,
    formatDateUrl,
    isWithinTimeFrame,
  },
};
</script>
